module.exports = __webpack_public_path__ + "static/media/img_growth.6eead420.png";